import React from "react";

import Link from "next/link";
import FacebookIcon from "public/icons/socialmedia-facebook.svg";
import InstagramIcon from "public/icons/socialmedia-instagram.svg";
import TwitterIcon from "public/icons/socialmedia-twitter.svg";

import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";

export const SocialMediaIcons: React.FC = () => {
  return (
    <div className="flex gap-1 mt-2">
      <Link
        href={"https://www.instagram.com/golden.brides/"}
        target="_blank"
        aria-label="Instagram"
      >
        <SvgIcon width={36} height={36} color="grey">
          <InstagramIcon />
        </SvgIcon>
      </Link>
      <Link
        href={"https://www.facebook.com/GoldenBridedating/"}
        target="_blank"
        aria-label="Facebook"
      >
        <SvgIcon width={36} height={36} color="grey">
          <FacebookIcon />
        </SvgIcon>
      </Link>
      <Link
        href={"https://twitter.com/GoldenBride1"}
        target="_blank"
        aria-label="Twitter"
      >
        <SvgIcon width={36} height={36} color="grey">
          <TwitterIcon />
        </SvgIcon>
      </Link>
    </div>
  );
};
